// Sıralama sonrası hesap grubu değişimi (TODO-KPI-151): `calculation_group_metric_id` NULL olan
// toplamlarda hesap grubu "ilk tam grup"tur (orderIndex); sürükleme/↑↓ grup sırasını değiştirince
// grup sessizce değişebilir. Orijinal ↔ taslak karşılaştırması; iki seviyeli kırılımda seviye-1
// üye toplamı da (altında grup olan üye) aynı kuralla izlenir.

import { type KpiSetIndicator } from "@mahir/shared";
import { calcGroupChangeEntries } from "./kpi-breakdown-set";

export interface CalcGroupChange {
  totalLabel: string;
  from: string;
  to: string;
}

export function calcGroupChanged(
  before: readonly KpiSetIndicator[],
  after: readonly KpiSetIndicator[],
): CalcGroupChange[] {
  return calcGroupChangeEntries(before, after).map((e) => ({
    totalLabel: e.name,
    from: e.from,
    to: e.to,
  }));
}
